import { $request } from "@/api"

export default {
  state: {
    activePanelName: '',
    center: {},
    timeScopeCn: '',
    timeScope: '',
    educationStage: ''
  },
  mutations: {
    setEducationStage(state, value) {
      state.educationStage = value
    },
    setTimeScope(state, { text, value }) {
      state.timeScopeCn = text
      state.timeScope = value
    },
    setActivePanelName(state, panelName) {
      state.activePanelName = panelName
    },
    registerEvent(state, event) {
      if (!state.center[event]) state.center[event] = []
    },
    deleteEvent(state, event) {
      if (state.center[event] && state.center[event].length) state.center[event] = []
    },
    clearEvent(state) {
      Object.keys(state.center).forEach(i => {
        state.center[i] = []
      })
    },
    addEventCallBackFunc(state, { event, func }) {
      if (state.center[event]) {
        state.center[event].push(func)
      }
    }
  },
  actions: {
    triggerEvent({ state }, event) {
      if (state.center[event]) {
        state.center[event].forEach(func => func())
      }
    },
    changeEducationStage({ state, commit, dispatch }, params) {
      commit('setEducationStage', params)
      commit('gradeAndSubject/setGradeAndSubjectData', params)
      dispatch('triggerEvent', `educationStageChange`)
      console.log('educationStageChange')
    },
    changeTimeScope({ commit, dispatch }, params) {
      commit('setTimeScope', params)
      dispatch('triggerEvent', `timeScopeChange`)
      console.log('timeScopeChange')
    },
    $request({ rootState, state }, requestConfig) {
      const {
        key = typeof requestConfig === 'string' ? requestConfig : '',
        data = {},
        config = {}
      } = typeof requestConfig === 'object' ? requestConfig : {}
      return new Promise((resolve, reject) => {
        const params = {
          // cityId: rootState.user.eduBureauInfo.cityId,
          eduBureauId: rootState.user.eduBureauId,
          stage: state.educationStage,
          dateQueryType: state.timeScope,
          ...data
        }
        if (params.dateQueryType === '1') {
          params.year = rootState.user.semesterInfo.year
          params.semesterName = rootState.user.semesterInfo.semesterName
        }
        if (config.grade) {
          params.gradeNumber = rootState.gradeAndSubject.gradeData[rootState.gradeAndSubject.gradeIndex].value
        }
        if (config.subject) {
          params.subjectId = rootState.gradeAndSubject.subjectData[rootState.gradeAndSubject.subjectIndex].value
        }
        $request(key, params).then(res => resolve(res || {})).catch(e => reject(e))
      })
    }
  }
}
